import { useQuery } from "@tanstack/react-query";
import { Wallet } from "lucide-react";
import { AppLink, cx } from "@amber/ui";
import { budgetBannerQuery } from "../queries";

export function BudgetBanner() {
  const query = useQuery(budgetBannerQuery);
  const banner = query.data?.banner;
  if (!banner) return null;
  const failed = banner.tone === "failed";
  return (
    <div
      role="status"
      aria-label="Budget"
      className={cx(
        "flex min-h-[38px] flex-none items-center gap-2 border-b px-4 text-md max-compact:px-2",
        failed ? "border-attention/40 bg-attention-soft" : "border-waiting/40 bg-waiting-soft",
      )}
    >
      <Wallet
        size={14}
        strokeWidth={1.8}
        aria-hidden="true"
        className={cx("flex-none", failed ? "text-attention" : "text-waiting")}
      />
      <p className="m-0 min-w-0 flex-1 truncate">
        <b className="font-semibold">{banner.text}</b>
        <span className="text-muted"> · {banner.detail}</span>
      </p>
      <AppLink href="/settings/budgets" className="px-1.5 font-strong text-fg no-underline hover:underline">
        Budgets
      </AppLink>
    </div>
  );
}
